/**
 * DemoPage — публичная демо-страница Anima.
 *
 * 3-column comparison: Клиент → Shadow Draft → Оператор.
 * Лимит: 3 сообщения.
 */

import { DemoExperience } from '../components/demo/DemoExperience';

export function DemoPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-surface-base flex flex-col">
      {/* Header */}
      <header className="border-b border-border-subtle bg-surface-elevated px-6 py-4">
        <div className="max-w-5xl mx-auto flex items-center gap-3">
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-comp bg-accent-brand flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
              <span className="text-sm font-bold text-white font-heading">A</span>
            </div>
            <span className="text-lg font-heading font-bold text-text-primary">Anima</span>
          </a>
          <div className="ml-2">
            <h1 className="font-heading font-bold text-sm text-text-primary">Demo — Shadow Mode</h1>
            <p className="text-xs text-text-secondary">AI-ассистент для клиентской поддержки</p>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 max-w-5xl mx-auto w-full px-6 py-8">
        <DemoExperience />
      </main>
    </div>
  );
}
